export default "__VITE_ASSET__84c4c1bd__"